// extracted by mini-css-extract-plugin
export default {"input_width":"vendor-pass_input_width__GXVe9","row":"vendor-pass_row__XqUk7","column":"vendor-pass_column__8S5X4"};